import script from "./Step2SeleccionBoleto.vue?vue&type=script&setup=true&lang=js"
export * from "./Step2SeleccionBoleto.vue?vue&type=script&setup=true&lang=js"

import "./Step2SeleccionBoleto.vue?vue&type=style&index=0&id=3a4dc591&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a4dc591"]])

export default __exports__